import axios from "../axiosInstance";

const sportAPI = {
  store: (payload) => axios.post("admin/sport/store", payload),
  getList: (params) => axios.get("admin/sport/list", {params}),
  getAll: () => axios.get("admin/sport/getall"),

  getAllforGameCreation: () => axios.get("admin/sport/getAllforGameCreation"),
  
  update: (payload) => axios.post("admin/sport/update", payload),
  delete: (payload) => axios.post("admin/sport/delete", payload),
};

export default sportAPI;
